import { Component, OnInit } from '@angular/core';
import { WebSocketService } from './dashboard/services/web-socket.service';
import { SwalService } from '../app/shared/services/swal.service';
import { UserProfileService } from './dashboard/services/user-profile.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'drogueriavirtualvtex';
  currentUserRoleIds: number; // Array de roles permitidos
  lastNotification: any;
  userInfo: UserInfo;

  constructor(private webSocketService: WebSocketService, private _swal: SwalService, private _profile: UserProfileService) { }

  ngOnInit() {
    const token = localStorage.getItem('token');

    if (token) {
      this.getUserInfo();
    }

    this.webSocketService.messageSubject.subscribe((message: any) => {
      if (
        message.notification &&
        this.userInfo &&
        this.userInfo.roles &&
        this.userInfo.roles.length > 0 &&
        this.userInfo.roles[0].id === message.notification.role_id
      ) {
        const { title, description, number_order } = message.notification;
        this._swal.showSuccessNotificationSocket(title, description, number_order);
      }
    });

  }


  getUserInfo() {
    this._profile.getUserProfileInformation().subscribe(
      (data: any) => {
        this.userInfo = data.response;
      },
      (error) => {
        console.log(error);
        this._swal.errorHandler(error);
      }
    );
  }
}

interface UserInfo {
  id: number;
  name: string;
  last_name: string;
  cell_phone: string;
  dni: string;
  email: string;
  roles: any;
}
